import {
  Box,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import apiService from "../Services/api.service";
import { useToast } from "./Toast";
import PageLoader from "./Loader";
// Mock API response structure

const OverAllMonthwise = () => {
  const currentYear = new Date().getFullYear();
  const theme = useTheme();
  const auth = localStorage.getItem("token");
  const [isLoader, setIsLoader] = useState(false);
  const entityId = localStorage.getItem("entityId")
  const years = Array.from({ length: currentYear - 2020 + 1 }, (_, i) =>
    (2020 + i).toString()
  ).reverse();
  const Toast = useToast();
  const [year, setYear] = useState(currentYear.toString());
  const [data, setData] = useState([]);
  const getBardata = async () => {
    try {
      const startDate = `01/01/${year}`;
      const endDate = `31/12/${year}`;

      const res = await apiService.getOverAllMonthwise(
        auth,
        startDate,
        endDate,
        entityId
      );

      // Sort months from Jan to Dec
      const sortedData = [...res.data].sort((a, b) => {
        const monthOrder = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];

        const monthA = a.month.split(" ")[0];
        const monthB = b.month.split(" ")[0];

        return monthOrder.indexOf(monthA) - monthOrder.indexOf(monthB);
      });

      setData(sortedData);
      console.log("Sorted Response:", sortedData);
    } catch (error) {
      setIsLoader(false);
      Toast.error("Error fetching month-wise data");
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getBardata();
  }, [year]);

  const totalCount = data.reduce((sum, item) => sum + item.count, 0);

  return (
    <Card sx={{ borderRadius: "12px", p: 2 }}>
      <CardContent>
         <Box display="flex" alignItems="center" gap={2} mb={2}>
          <Typography variant="h6" fontWeight={600}>
            Monthly Scans Detected
          </Typography>
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel>Year</InputLabel>
            <Select
              value={year}
              label="Year"
              onChange={(e) => setYear(e.target.value)}
            >
              {years.map((y) => (
                <MenuItem key={y} value={y}>
                  {y}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Typography sx={{ mt: 2, mb: 1 }} variant="body2">
          Total scans detected in {year}
        </Typography>
        <Typography variant="h4" fontWeight={600} sx={{ mb: 3 }}>
          {totalCount.toLocaleString()}
        </Typography>

        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data}>
            <XAxis
              dataKey="month"
              tickFormatter={(month) => month.split(" ")[0].slice(0, 3)}
              tick={{ fontSize: 12 }}
              interval={0}
            />
            <YAxis />
            <Tooltip />
            <Bar dataKey="count" fill={theme.Bars.main} radius={4} />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
      {isLoader && <PageLoader/>}
    </Card>
  );
};

export default OverAllMonthwise;
